<template>


  <div class="container container-tabs">


    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">

      <el-tab-pane name="all" class="to-searh">
        <span slot="label" class="table-title">全部</span>
      </el-tab-pane>

      <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_code" :key="index" class="to-searh">
        <span slot="label" class="table-title">{{ item.alias }}</span>
      </el-tab-pane>







      <div class="handle-box">

        <el-button type="primary" icon="el-icon-search" @click="searchCoupon">搜索</el-button>
        <el-button @click="add_isShow=!add_isShow">添加</el-button>
        <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

      </div>



    </el-tabs>






    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">

      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">

            <div class="more-style">

              <el-form-item label="可用时段:">
                <div  v-for="item in props.row.time_synchronization">
                  <span>{{ item.start_time }}</span>
                  -
                  <span>{{ item.end_time }}</span>
                </div>
              </el-form-item>
              <el-form-item label="可用日期:">
                <p v-for="item in props.row.date_synchronization.month">{{ item }}月</p>
                <p v-for="item in props.row.date_synchronization.day">{{ item }}日</p>
                <p v-for="(item,index) in props.row.date_synchronization.week">星期{{ week_lists_chinese[item] }}</p>
              </el-form-item>
              <el-form-item label="领取限制:">
                <p>每年{{ props.row.receive_synchronization.year }}张</p>
                <p>每月{{ props.row.receive_synchronization.month }}张</p>
                <p>每周{{ props.row.receive_synchronization.week }}张</p>
                <p>每天{{ props.row.receive_synchronization.day }}张</p>
              </el-form-item>

            </div>

            <div class="more-style">

              <el-form-item label="唯一编码:">
                <span>{{ props.row.coupon_mode_code }}</span>
              </el-form-item>

              <el-form-item label="创建时间:">
                <span>{{ props.row.time.Ymd }}</span>
              </el-form-item>

              <el-form-item label="创建详细时间:">
                <span>{{ props.row.time.YmdHis }}</span>
              </el-form-item>

            </div>

            <div class="more-style">

              <el-form-item label="可用时间:">
                <span>{{ props.row.start_time.Ymd }}</span>
              </el-form-item>

              <el-form-item label="可用详细时间:">
                <span>{{ props.row.start_time.YmdHis }}</span>
              </el-form-item>
              <el-form-item label="过期时间:">
                <span>{{ props.row.end_time.Ymd }}</span>
              </el-form-item>

            </div>



            <div class="more-style">

              <el-form-item label="过期详细时间:">
                <span>{{ props.row.end_time.YmdHis }}</span>
              </el-form-item>

            </div>

          </el-form>
        </template>
      </el-table-column>


      <el-table-column prop="id" label="id" width="80">
      </el-table-column>

      <el-table-column prop="name" label="优惠券名称" width="150">
         <template slot-scope="scope">
           {{scope.row.name}}
           <span v-if="scope.row.is_pingan == '1'">(平安)</span>
         </template>
      </el-table-column>


      <el-table-column prop="name" label="优惠券类别" width="150">
        <template slot-scope="scope">
          {{scope.row.inspection == '1'?'检车线':'代驾'}}

        </template>
      </el-table-column>

      <el-table-column prop="city.name" label="所属城市" width="300">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>城市唯一编码: {{ scope.row.city.city_code }}</p>
            <div slot="reference">
              <el-tag size="medium" style="border:0;background-color:#FFF;color:#333">{{ scope.row.city.name}}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column prop="full_price" label="满减条件" width="150">
      </el-table-column>

      <el-table-column prop="sub_price" label="满减金额" width="150">
      </el-table-column>

      <el-table-column prop="quantity" label="剩余数量">
      </el-table-column>

      <el-table-column prop="grant_quantity" label="发行数量">
      </el-table-column>

      <el-table-column prop="coupon_tag" label="标签" width="200">
      </el-table-column>

      <el-table-column prop="use_num" label="核销数量" width="150">
      </el-table-column>

      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status.val=='0'?'warning':(scope.row.status.val=='1'?'':'danger')">
            {{scope.row.status.alias}}</el-tag>
        </template>
      </el-table-column>



      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-button type="primary"
            @click="edit_isShow = !edit_isShow; editCoupon_children = scope.row.coupon_mode_code;inspection_status = scope.row.inspection">

            编辑



          </el-button>

        </template>
      </el-table-column>
    </el-table>


    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>

    <!-- 添加优惠券组件 -->
    <addCoupon :isShow="add_isShow" @onSubmit="couponLists"></addCoupon>

    <!-- 修改优惠券组件 -->
    <editCoupon :isShow="edit_isShow" :data="editCoupon_children" :inspection_status="inspection_status" @onSubmit="couponLists"></editCoupon>

  </div>


</template>

<script>
  var _this;
  // import bus from '../../common/bus.js';
  import addCoupon from './addCoupon.vue';
  import editCoupon from './editCoupon.vue';
  export default {
    components: {
      addCoupon,
      editCoupon
    },
    data() {
      return {

        inspection_status:'',

        // 选项卡默认选中项
        activeName: 'all',

        // 添加用户信息组件开关
        add_isShow: false,

        // 修改用户信息组件开关
        edit_isShow: false,

        week_lists_chinese: ['','一', '二', '三', '四', '五', '六', '日'],



        // 传入子组件的数据
        editCoupon_children: '',



        // 下拉搜索状态
        value_status_code: '',
        status_select: [],

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          status: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },
      };
    },
    created() {

      _this = this;

      _this.couponLists();


    },

    methods: {



      searchCoupon() {
        _this.search_data.page = 1;
        _this.couponLists();
      },

      // 选项卡选中事件
      handleClick(tab, event) {
        // 点击的选项卡所对应的val值
        console.log(tab.name);
        if (tab.name != 'all') {
          _this.search_data.status = tab.name;
        } else {
          _this.search_data.status = '';
        }
        _this.search_data.page = 1;
        _this.couponLists();

      },

      // 搜索用户管理列表
      couponLists() {

        _this.$post(
            "/coupon/CouponModeLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;
            // 状态下拉的数据
            _this.value_status_code = _this.tableData[0].status.select_array;
            console.log(_this.value_status_code);



          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.couponLists();

      },
      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].driver_code);

        }
        _this.delDriverSubmit_data.driver_code_array = datalist;
      },

      statusChange(val) {
        console.log(val.toString());

        _this.search_data.status = val.toString();

      },

      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

      // 解绑设备
      untying(code) {

        _this.$post(
          "/driver/untyingDriverMobileSubmit", {
            driver_code: code
          }
        ).then(res => {

          _this.$message.success('解绑设备成功');

        }).catch((err) => {

        })

      }
    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown+.el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

  .title {
    width: 120px !important;
  }
</style>